<template>
    <div id="campaign_list">
        <div class="loading" :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="canAccessPage === true">
                <div class="page-name">
                    <div class="page-title">Campaigns</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <router-link v-if="canAddCampaign" class="btn btn-primary pull-right" v-bind:to="{name: 'CampaignCreate'}" > <i class="fp-add"> </i> Add</router-link>
                </div>
                <div class="container-fluid">
                    <div class="from-group">
                        <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <strong id="errorMsg" class="field-error"></strong>
                        </div>
                    </div>
                    <div class="admin-page-content campaign-list">
                        <data-table-filter-config :moduleName="'campaignList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'campaignList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listCampaign"
                                    mode="remote"
                                    title="Campaigns"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                        enabled: deleteBtnAccess,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                        enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <a v-if="canViewLog" title="View Log" v-on:click.prevent="goToGetLogInfo(props.row.id)" class="fp-log-file-format" href="javascript:void(0)"></a>
                                                <router-link title="Edit Campaign" v-if="canUpdateCampaign" class="fp-edit" v-bind:to="{name: 'CampaignEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else-if="props.column.field == 'link'">
                                                <a v-on:click="goTogetDocumentPath($event, props.row)" title="View Document" href="" style="font-size: 15px;"><i class="fp-text-document"></i></a>
                                            </div>
                                            <div v-else>
                                              {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="deleteBtnAccess" id="deleteCampaignBtn" v-on:click.prevent="campaignDelete" class="btn btn-primary">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                  <audit-log-popup :logs="logs" :popUpTitle="popUpTitle" :fileFlag="fileFlag"></audit-log-popup>
                </div>
            </template>
            <template v-else-if="canAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);
import EventBus from "../event-bus";
import 'vue-good-table/dist/vue-good-table.css';
import VueGoodTable from 'vue-good-table';
import AuditLogPopUp from "../AuditLogPopUp.vue";
Vue.component("audit-log-popup",AuditLogPopUp);

Vue.use(VueGoodTable);

import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

    export default {
        name: "CampaignList",
        components: {
            customPagination: () => import('@/components/layout/CustomPagination'),
            dataTableFilterConfig: () => import('@/components/DataTableFilterConfig'),
            clearCacheData: () => import('@/components/ClearCacheData'),
            appFooter: () => import('@/components/Footer'),
        },
        mixins:[commonMixins,dataTableMixins],
        metaInfo() {
            return {title: "Campaigns | " + process.env.COPYRIGHT_NAME}
        },
        data: () => ({
            permissions: [],
            canAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                    hidden: true,
                },
                {
                    label: 'Campaign / FFP code',
                    field: 'ffp_code',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "FFP Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                  label: 'Campaign Type',
                  field: 'campaign_type',
                  fpFieldType:"option",
                  hidden:false,
                  filterable: true,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Campaign Type Value", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [
                      {value:'campaign',text:'Campaign'},
                      {value:'recall ',text:'Recall'}
                    ],
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
                {
                  label: 'Campaign Status',
                  field: 'campaign_status',
                  fpFieldType:"option",
                  hidden:false,
                  filterable: true,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Campaign Status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: [{value:'active',text:'Active'},
                      {value:'inactive ',text:'Inactive'}],
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
                {
                  label: 'Campaign Start Date',
                  field: 'campaign_start_date',
                  fpFieldType:"date",
                  hidden:false,
                  filterable: true,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                  // sortable:false
                },
                {
                  label: 'Campaign End Date',
                  field: 'campaign_end_date',
                  fpFieldType:"date",
                  hidden:false,
                  filterable: true,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                  // sortable:false
                },
                {
                    label: 'Publication Date',
                    field: 'created_at',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Publication Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Revision Date',
                    field: 'updated_at',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Revision Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Documents',
                    field: 'link',
                    sortable: false,
                    filterable: false,
                },
            ],
            rows: [],
            totalRecords: 0,
            deleteBtnAccess: false,
            loading:false,
            canUpdateCampaign:false,
            canAddCampaign:false,
            pageKey:"_campaign_list_",
            errorMsg: "",
            canViewLog: false,
            logs: [],
            popUpTitle: "Campaign/Recall Activity Log Details",
            fileFlag: "campaign"
        }),
        watch: {
            //check permission change
          permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
              for (var i = 0; i < permissions.length; i++) {
                if (permissions[i].name == 'ev_list_campaign') {
                  self.canAccessPage = true;
                }
                if (permissions[i].name == 'ev_add_campaign') {
                  self.canAddCampaign = true;
                }
                if (permissions[i].name == 'ev_edit_campaign') {
                  self.canUpdateCampaign = true;
                }
                if (permissions[i].name == 'ev_delete_campaign') {
                  self.deleteBtnAccess = true;
                }
                if (permissions[i].name == 'ev_view_log_campaign_recall') {
                  self.canViewLog = true;
                  const actionColumn = this.columns.find(column => column.field === 'action');
                  if (actionColumn) {
                    actionColumn.hidden = false;
                  }
                }
              }
            }
          }
        },
        mounted: function() {
            var self = this;
            self.getPermissions();
        },
        methods: {
            cancelAll: function () {
              this.$refs.listCampaign.unselectAllInternal();
            },

            selectionChanged(param) {
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
            },
            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                };
                $.ajax({
                    url: process.env.ROOT_API + "/campaign/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            $("#errorMsg").html(jqXHR.responseJSON.message);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                });
            },
            campaignDelete(){
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Campaign?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        var data = this.$refs['listCampaign'].selectedRows;
                        var use = [];
                        for (var i = 0; i < data.length; i++) {
                            use.push(this.$refs['listCampaign'].selectedRows[i].id)
                        }
                        self.loading = true;
                        $("#deleteCampaignBtn").val("Deleting ...");
                        $.ajax({
                          url: process.env.ROOT_API + "/campaign/delete",
                          type: "POST",
                          data: 'ids=' + use,
                          headers: this.ajxHeaders,
                          dataType: 'json',
                          success: function (data) {
                              self.loading = false;
                              setTimeout(function () {
                                  $("#deleteCampaignBtn").val("Delete");
                              }, 1000);
                              if (data.code == '200') {
                                  self.loadList();
                              }
                          },
                          error: function (jqXHR, exception) {
                            self.loading = false;
                            if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("tkn");
                                    self.$router.push("/");
                                }
                                $("#errorMsg").html(jqXHR.responseJSON.message);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 5000);
                            }
                          }
                      });
                    }
                });
            },

            goToGetLogInfo(logId){
                var self = this;
                var logFlag = 'CAMPAIGN_AUDIT';

                self.getLogInfo(logId, logFlag);
            },

            goTogetDocumentPath(event, row){
                event.preventDefault();
                var self = this;
                let path = "";
                if(row.hasOwnProperty('link')){
                    path = row.link;
                }else{
                    path = row;
                }
                var flag = self.fileFlag;
                var id = 0;
                if(row.id > 0){
                    id = row.id;
                }
                self.getDocumentPath(id, path, flag);
            },
        }
    };
</script>

<style scoped>
.data-table table.vgt-table .fp-log-file-format {
    font-size: 15px;
}
.loading{
    z-index: 1060 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/campaign/CampaignList.vue